<template>
  <div class="container">
    <div class="header">
      <img src="\Images\Image.png" alt="The Universal Insurance Company Limited Logo">
      <div class="header-text">
        <div class="title">The Universal Insurance Company Limited</div>
        <div class="subtitle">Know Your Customer (KYC) / Customer Due Diligence (CDD) Form</div>
        <div class="individual">( Business/ Legal Entities )</div>
      </div>
    </div>

    <div class="date-line">
      Date: <span class="input-line"></span>
    </div>
    <div class="form-row">
      Customer Name <span class="input-line">{{ item.BP_DSC }}</span>
      Branch Code: <span class="input-line">{{ item.BRANCH_ID }}</span>
    </div>

    <div class="form-row">
      Address <span class="input-line">{{ item.BP_ADDRESS }}</span>
      Client Code: <span class="input-line">{{ item.BP_CODE_NEW}}</span>
    </div>

    <div class="form-section">
      <div class="section-title">Customer Legal Status/ Structure</div>

      <div class="form-row">
        a) Sole Proprietorship <span class="checkbox"></span>
        b) Partnership <span class="checkbox"></span>
        c) Limited Liability Partnership (LLP) <span class="checkbox"></span>
        d) Limited Company/Corporations <span class="checkbox"></span>
        e) Branch Office or Liaison Office of Foreign Company <span class="checkbox"></span>
        f) Trust, Clubs, Societies & Associations <span class="checkbox"></span>
        g) NGOs/ NPOs/ Charities <span class="checkbox"></span>
        h) Agents <span class="checkbox"></span>
        i) Executors and Administrators <span class="checkbox"></span>
        j) Others (Specify) <span class="input-line"></span>
      </div>
    </div>

    <div class="form-section" style="page-break-after: always">
      <div class="section-title">Company Information</div>

      <div class="form-row">
        Incorporation Registration No: <span class="input-line">{{ item.BP_REGISTRATIONNO }}</span>
        Date of Incorporation/ Registration: <span class="input-line">{{ item.BP_DOREGISTRATION }}</span>
        Nature of Business: <span class="input-line">{{ item.BP_BUSINESSNAME }}</span>
        Registered or Business Address: <span class="input-line">{{ item.BP_BUSINESSADDRESS }}</span>

      </div>
      <div class="form-row">
        NTN: <span class="input-line">{{ item.BP_NTN_NO }}</span>
        STR No: <span class="input-line">{{ item.BP_GST_NO }}</span>
        Taxpayer Status: Filer <span class="checkbox">{{ item.BP_ISACTTAXPAY === '1' ? '✔' : '' }}</span> Non Filer <span class="checkbox">{{ item.BP_ISACTTAXPAY === '0' ? '✔' : '' }}</span>
        Telephone No: <span class="input-line">{{ item.BP_PHONE }}</span>
        Email ID: <span class="input-line">{{ item.BP_EMAIL_ADDRESS }}</span>
        Web: <span class="input-line">{{ item.BP_URL_ADDRESS }}</span>
      </div>
      <div class="form-row">
        Source of Income: Business <span class="checkbox">{{ item.BP_SOURCEOFINCOME === 'Business' ? '✔' : '' }}</span> Charity/Donation <span class="checkbox">{{ item.BP_SOURCEOFINCOME === 'Charity/Donation' ? '✔' : '' }}</span> Other (Specify): <span class="input-line">{{ item.BP_SOURCEOFINCOME_SPFY }}</span>
      </div>

      <div class="form-row">
        Purpose and intended nature of Business Relationship with UIC: <span class="input-line">{{ item.BP_PURPOSEANDINT }}</span>
        Type of Account/ Financial Transaction/ Financial Services: <span class="input-line">{{ item.BP_TYPREOFAC }}</span>
        Expected monthly turnover (amount & No. of transaction): <span class="input-line">{{ item.BP_EXPECTEDMONTHLYTRUN }}</span>
        Normal or expected modes of Transactions/ Delivery Channels: <span class="input-line">{{ item.BP_NORMALOREXPMODE }}</span>
      </div>

      <div class="form-row">
        Main Geographically area of activity Within Pakistan (Specify): <span class="input-line">{{ item.BP_MAINGAOAWITHINPAK }}</span>
      </div>
      <div class="form-row">
        Outside Pakistan (Specify): <span class="input-line">{{ item.BP_OUTSIDEPAKACTIVITY }}</span>
      </div>
      <div class="form-row">
        <div class="form-field">
          Contact Person Name: <span class="input-line">{{ item.BP_CONTACT_PERSON }}</span>
        </div>
        <div class="form-field">
          Designation: <span class="input-line">{{ item.BP_DESIGNATION }}</span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          CNIC No: <span class="input-line">{{ item.BP_CPCNICNO }}</span>
        </div>
        <div class="form-field">
          Cell No: <span class="input-line">{{ item.BP_CPCELLNO }}</span>
        </div>
        <div class="form-field">
          Email: <span class="input-line">{{ item.BP_CPEMAIL }}</span>
        </div>
      </div>
    </div>

    <div style="margin-bottom: 10px; font-weight: bold; font-size: 10pt;">
      Please review the definition of PEP provided below & reply, if applicable, for any of your Owners/ Promotors/ Partners/ Directors/ Trustees:
    </div>

    <div class="form-section">
      <div class="section-title" style="font-weight: bold; font-size: 10pt;">Information of Directors/ Partners/ Trustees etc.</div>
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>CNIC/ NICOP/ Passport No.</th>
            <th>CNIC/ NICOP/ Passport Issue Date</th>
            <th>CNIC/ NICOP/ Passport Expiry Date</th>
            <th>PEP Yes/ No</th>
            <th>If yes, Self/ Position</th>
            <th>If yes By way of family member/ close associates, state relation & Position held</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(owner, index) in item.DirectorInfo" :key="index">
            <td>{{ owner.BO_NAME || '-' }}</td>
            <td>{{ owner.BO_CNICPASSNO || '-' }}</td>
            <td>{{ owner.BO_CNICPASS_ISSUEDTE || '-' }}</td>
            <td>{{ owner.BO_CNICPASS_EXPDTE || '-' }}</td>
            <td>{{ owner.BO_PEPYN || '-' }}</td>
            <td>{{ owner.BO_IFYESSELFPOSITION || '-' }}</td>
            <td>{{ owner.BO_ASSOCRELWITHPEP || '-' }}</td>
          </tr>
          <tr v-if="!item.DirectorInfo || item.DirectorInfo.length === 0">
            <td colspan="7">No Director Info found</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="form-section">
      <div class="section-title" style="font-weight: bold; font-size: 10pt;">Particulars of Your Entity's Shareholders (both individual & companies) having more than 10% holding</div>
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>CNIC/ NICOP/ Passport/ Registration No.</th>
            <th>% of share held</th>
            <th>CNIC/ NICOP/ Passport Issue Date</th>
            <th>CNIC/ NICOP/ Passport Expiry Date</th>
            <th>PEP Yes/ No</th>
            <th>If yes, Self/ Position</th>
            <th>If yes By way of family member/ close associates, state relation & Position held</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(owner, index) in item.BeneficialOwners" :key="index">
            <td>{{ owner.BO_NAME || '-' }}</td>
            <td>{{ owner.BO_CNICPASSNO || '-' }}</td>
            <td>{{ owner.BO_SHAREPERCENTAGE || '-'}}</td>
            <td>{{ owner.BO_CNICPASS_ISSUEDTE || '-' }}</td>
            <td>{{ owner.BO_CNICPASS_EXPDTE || '-' }}</td>
            <td>{{ owner.BO_PEPYN || '-' }}</td>
            <td>{{ owner.BO_IFYESSELFPOSITION || '-' }}</td>
            <td>{{ owner.BO_ASSOCRELWITHPEP || '-' }}</td>
          </tr>
          <tr v-if="!item.BeneficialOwners || item.BeneficialOwners.length === 0">
            <td colspan="7">No shareholders found</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="form-section">
      <div class="section-title">Declaration</div>

      <div class="declaration">
        1. I/ We confirm that the details furnished above are true, complete and accurate to the best of my/ our knowledge and belief and further I/ We undertake that any change in this regard will be duly communicated to the Company for updation of their records, failing which, I/ We will indemnify the Company for any loss resulting from my/ our failure to honor the afore-stated undertaking.
      </div>

      <div class="declaration">
        2. I/ We agree to provide reasonable and unconditional consent to The Universal Insurance Company Limited to verify, as and when required, at the sole discretion of the Company, any or all CNIC from NADRA and other credentials as a Corporate Entity furnished by me/us from relevant regulators.
      </div>

      <div class="signature-line">
        <div class="signature">
          <div class="signature-box"></div>
          Name & Designation of (Authorized Signatory)
        </div>
        <div class="signature">
          <div class="signature-box"></div>
          Signature & Stamp
        </div>
      </div>

      <div class="signature-line">
        <div class="signature">
          <div class="signature-box"></div>
          Name & Designation of (Authorized Signatory)
        </div>
        <div class="signature">
          <div class="signature-box"></div>
          Signature & Stamp
        </div>
      </div>

      <div style="text-align: center; margin-top: 20px; font-weight: bold;">
        Relationship Manager - The Universal Insurance Co. Ltd.
      </div>
    </div>

    <div class="form-section">
      <div class="section-title">To be filled by Marketing Staff</div>

      <div style="text-align: center; margin-bottom: 20px;">
        I have checked this KYC form and the required documents and certify that these are in order.
      </div>

      <div class="signature-line">
        <div class="signature">
          Sign / Date: <span class="input-line"></span>
          <div style="margin-top: 10px;">Field Officer</div>
        </div>
        <div class="signature">
          Sign / Date: <span class="input-line"></span>
          <div style="margin-top: 10px;">Branch Head</div>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="section-title">Documents Required</div>
      <div style="text-align: center; font-size: 10pt; margin-bottom: 10px;">
        As per attached Annexure - A
      </div>
    </div>

    <div class="form-section">
      <div class="section-title">Definition of Politically Exposed Person (PEP)</div>

      <div class="pep-definition">
        <ol>
          <li>Foreign PEPs: individuals who are or have been entrusted with prominent public functions by a foreign country, for example Heads of State or of government, senior politicians, senior government, judicial or military officers, senior executives of state owned corporations, important political party officials.</li>
          <li>Domestic PEPs: individuals who are or have been entrusted domestically with prominent public functions, for example Heads of State or of government, senior politicians, senior government, judicial or military officers, senior executives of state owned corporations, important political party officials.</li>
          <li>Persons who are or have been entrusted with a prominent function by an international organization, means members of senior management and members of the board or equivalent functions.</li>
          <li>Provided that middle ranking or more junior individuals in the above referred categories are not included in the definition of PEPs.</li>
        </ol>
      </div>
    </div>
    <div class="header">
      <img src="\Images\uic.png" alt="The Universal Insurance Company Limited Logo">
      <div class="header-text">
        <div class="title">The Universal Insurance Company Limited</div>
        <div class="individual">Section relevant to your Entity please attached the documents mentioned below</div>
        <h2 style="text-align:right">Annexure - A</h2>
      </div>
    </div>
    <table>
      <tr>
        <th>Customer Legal Status/ Structure</th>
        <th>Sr. #</th>
        <th>Minimum Documents required for CDD</th>
        <th>Check List</th>
      </tr>
      <tr>
        <td rowspan="7">a) Sole Proprietorship</td>
        <td>1</td>
        <td>
          A copy of any one of the following valid identity documents:<br>
          (i) Computerized National Identity Card (CNIC)/Smart National Identity Card (SNIC) issued by NADRA.<br><hr />
          (ii) National Identity Card for Overseas Pakistani (NICOP)/SNICOP) issued by NADRA.<br><hr />
          (iii) Form-B/Juvenile card/Child Registration Certificate(CRC) issued by NADRA to children under the age of 18 years.<br><hr />
          (iv) Pakistan Origin Card (POC) issued by NADRA.<br><hr />
          (v) Alien Registration Card (ARC) issued by National Aliens Registration Authority (NARA).<br><hr />
          (vi) Proof of Registration (POR) Card issued by NADRA.<br><hr />
          (vii) Passport; having valid visa on it or any other proof of legal stay along with passport (foreign national individuals only).
        </td>
        <td></td>
      </tr>
      <tr>
        <td>2</td>
        <td>Attested copy of registration certificate for registered concerns.</td>
        <td></td>
      </tr>
      <tr>
        <td>3</td>
        <td>Sales tax registration or NTN, wherever applicable.</td>
        <td></td>
      </tr>
      <tr>
        <td>4</td>
        <td>Account opening requisition on business letterhead.</td>
        <td></td>
      </tr>
      <tr>
        <td>5</td>
        <td>Registered/ Business address.</td>
        <td></td>
      </tr>
      <tr>
        <td>6</td>
        <td>Certificate or proof of membership of trade bodies etc. (if any)</td>
        <td></td>
      </tr>
      <tr>
        <td>7</td>
        <td>Branch/ Liaison office address.</td>
        <td></td>
      </tr>
      <tr>
        <td rowspan="5">b) Partnership</td>
        <td>1</td>
        <td>Copies of identity documents (as per Sr. No. 1 of a) of all the partners and authorized signatories.</td>
        <td></td>
      </tr>
      <tr>
        <td>2</td>
        <td>Attested copy of ‘Partnership Deed’</td>
        <td></td>
      </tr>
      <tr>
        <td>3</td>
        <td>Attested copy of Registration Certificate with Registrar of Firms. In case the partnership is unregistered, this fact shall be declared/mentioned on the Account Opening Form</td>
        <td></td>
      </tr>
      <tr>
        <td>4</td>
        <td>Authority letter from all partners, in original, authorizing the person(s) to operate firm’s account</td>
        <td></td>
      </tr>
      <tr>
        <td>5</td>
        <td>Registered/ Business address.</td>
        <td></td>
      </tr>
      <tr>
        <td rowspan="3">c) Limited Liability Partnership (LLP)</td>
        <td>1</td>
        <td>Copies of identity documents (as per Sr. No. 1 of a) of all the partners and authorized signatories.</td>
        <td></td>
      </tr>
      <tr>
        <td>2</td>
        <td>
          Certified Copies of:<br><hr />
          (a) Limited Liability Partnership Deed/Agreement.<br><hr />
          (b) LLP-Form-III having detail of partners/designated partner in case of newly incorporated LLP.<br><hr />
          (c) LLP-Form-V regarding change in partners/designated partner in case of already incorporated LLP.
        </td>
        <td></td>
      </tr>
      <tr>
        <td>3</td>
        <td>Authority letter signed by all partners, authorizing the person(s) to operate LLP account.</td>
        <td></td>
      </tr>
      <tr>
        <td rowspan="5">d) Limited Companies/ Corporations</td>
        <td>1</td>
        <td>
          Certified copies of:<br>
          (a) Resolution of Board of Directors for opening of account specifying the person(s) authorized to open and operate the account;<br><hr />
          (b) Memorandum and Articles of Association.
        </td>
        <td></td>
      </tr>
      <tr>
        <td>2</td>
        <td>Certified copy of latest ‘Form-A/Form-B’</td>
        <td></td>
      </tr>
      <tr>
        <td>3</td>
        <td>Incorporate Form II in case of newly incorporated company and Form A/ Form C whichever is applicable, and Form 09 in already incorporated companies.</td>
        <td></td>
      </tr>
      <tr>
        <td>4</td>
        <td>Copies of identity documents (as per Sr. No. 1 of a) of all the directors and persons authorized to open and operate the account;</td>
        <td></td>
      </tr>
      <tr>
        <td>5</td>
        <td>Copies of identity documents (as per Sr. No. 1 of a) of the beneficial owners.</td>
        <td></td>
      </tr>
      <tr>
        <td rowspan="7">e) Branch or Liaison Office of Foreign Companies</td>
        <td>1</td>
        <td>A copy of permission letter from relevant authority i.e. Board of Investment.</td>
        <td></td>
      </tr>
      <tr>
        <td>2</td>
        <td>Copies of valid passports of all the signatories/ account.</td>
        <td></td>
      </tr>
      <tr>
        <td>3</td>
        <td>List of directors on company letter head or prescribed format under relevant laws/ regulations.</td>
        <td></td>
      </tr>
      <tr>
        <td>4</td>
        <td>Certified copies of Form II about particulars of directors, Principal Officer etc. in case of newly registered branch or liaison office of a foreign company</td>
        <td></td>
      </tr>
      <tr>
        <td>5</td>
        <td>Certified copies of Form III about change in directors, principal officers etc. in already registered foreign company’s branch or liaison office of a foreign company</td>
        <td></td>
      </tr>
      <tr>
        <td>6</td>
        <td>A Letter from Principal Office of the entity authorizing the person(s) to open and operate the account.</td>
        <td></td>
      </tr>
      <tr style="page-break-after: always">
        <td>7</td>
        <td>Branch/ Liaison office address.</td>
        <td></td>
      </tr>
      <tr>
        <td rowspan="4">f) Trusts, Clubs, Societies and Associations etc.</td>
        <td>1</td>
        <td>
          Certified Copies of:<br><hr />
          (a) Certificate of Registration/ Instrument of Trust<br><hr />
          (b) By-laws/Rules & Regulations
        </td>
        <td></td>
      </tr>
      <tr>
        <td>2</td>
        <td>Resolution of the Governing Body/ Board of Trustees/ Executive Committee, if it is ultimate governing body, for opening of account authorizing the person(s) to operate the account.</td>
        <td></td>
      </tr>
      <tr>
        <td>3</td>
        <td>Copy of identity document (as per Sr. No. 1 of a) of the authorized person(s) and of the members of Governing Body/ Board of Trustees/ Executive Committee, if it is ultimate governing body.</td>
        <td></td>
      </tr>
      <tr>
        <td>4</td>
        <td>Registered address/ Business address where applicable.</td>
        <td></td>
      </tr>
      <tr>
        <td rowspan="5">g) NGOs/ NPOs/ Charities</td>
        <td>1</td>
        <td>
          Certified copies of:<br><hr />
          (a) Registration documents/certificate<br><hr />
          (b) By-laws/Rules & Regulations
        </td>
        <td></td>
      </tr>
      <tr>
        <td>2</td>
        <td>Resolution of the Governing Body/ Board of Trustees/Executive Committee, if it is ultimate governing body, for opening of account authorizing the person(s) to operate the account</td>
        <td></td>
      </tr>
      <tr>
        <td>3</td>
        <td>Copy of identity document (as per Sr. No. 1 of a) of the authorized person(s) and of the members of Governing Body/ Board of Trustees/ Executive Committee, if it is ultimate governing body.</td>
        <td></td>
      </tr>
      <tr>
        <td>4</td>
        <td>A copy of latest annual accounts/ financial statements.</td>
        <td></td>
      </tr>
      <tr>
        <td>5</td>
        <td>Registered address/ Business address.</td>
        <td></td>
      </tr>
      <tr>
        <td rowspan="3">h) Agents</td>
        <td>1</td>
        <td>Certified copy of ‘Power of Attorney’ or ‘Agency Agreement’.</td>
        <td></td>
      </tr>
      <tr>
        <td>2</td>
        <td>Copy of identity document (as per Sr. No. 1 of a) of the agent and principal.</td>
        <td></td>
      </tr>
      <tr>
        <td>3</td>
        <td>The relevant documents/papers from point no. a to e, if agent or the principal is not a natural person.</td>
        <td></td>
      </tr>
      <tr>
        <td rowspan="2">i) Executors and Administrators</td>
        <td>1</td>
        <td>Copy of identity document (as per Sr. No. 1 of a) of the Executor/Administrator.</td>
        <td></td>
      </tr>
      <tr>
        <td>2</td>
        <td>A certified copy of Letter of Administration or Probate</td>
        <td></td>
      </tr>
      <tr style="page-break-after: always">
        <td rowspan="1">j) Minor Accounts</td>
        <td>1</td>
        <td>Copy of Form-B; Birth Certificate/ Student ID card (as appropriate).</td>
        <td></td>
      </tr>
      <tr>
        <td rowspan="7">j) Mentally Disordered Person Account</td>
        <td>1</td>
        <td>Copy of identity document (as per Sr. No. 1 of a) of the guardian of the minor.</td>
        <td></td>
      </tr>
      <tr>
        <td>2</td>
        <td>Copy of applicable valid identity documents of mentally disordered person and court appointed manager under the applicable laws related to mental health;</td>
        <td></td>
      </tr>
      <tr>
        <td>3</td>
        <td>Certified true copy of court order for appointment of manager for mentally disordered person;</td>
        <td></td>
      </tr>
      <tr>
        <td>4</td>
        <td>Verification of court order from the concerned court/ authorized official.</td>
        <td></td>
      </tr>
      <tr>
        <td>5</td>
        <td>Account would be opened in the name of mentally disordered person and the same will be operated by the court appointed manager.</td>
        <td></td>
      </tr>
      <tr>
        <td>6</td>
        <td>All CDD requirements/ formalities should be conducted for both persons and</td>
        <td></td>
      </tr>
      <tr>
        <td>7</td>
        <td>In case of change of manager by the court, the CDD will be conducted for the new appointed manager by the Regulated Person afresh.</td>
        <td></td>
      </tr>
    </table>
  </div>
</template>
<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        item: {
          BP_ID: null,
          BP_DSC: "",
          BP_ADDRESS: "",
          BRANCH_ID: null,
          C_CODE: null,
          PVN_ID: null,
          CTY_ID: null,
          BP_ACTIVE: false,
          BP_REGISTRATIONNO: "",
          BP_DOREGISTRATION: "",
          BP_BUSINESSNAME: "",
          BP_BUSINESSADDRESS: "",
          BP_NTN_NO: "",
          BP_GST_NO: "",
          BP_ISACTTAXPAY: "",
          BP_PHONE: "",
          BP_EMAIL_ADDRESS: "",
          BP_URL_ADDRESS: "",
          BP_SOURCEOFINCOME: "",
          BP_SOURCEOFINCOME_SPFY: "",
          BP_MAINGAOAWITHINPAK: "",
          BP_OUTSIDEPAKACTIVITY: "",
          BP_CONTACT_PERSON: "",
          BP_DESIGNATION: "",
          BP_CPCNICNO: "",
          BP_CPCELLNO: "",
          BP_CPEMAIL: "",
          BP_PURPOSEANDINT: "",
          BP_TYPREOFAC: "",
          BP_EXPECTEDMONTHLYTRUN: "",
          BP_NORMALOREXPMODE: "",
          BP_CODE_NEW: "",
          BeneficialOwners: [],
          DirectorInfo:[]
        },
      }
    },
    created() {
      this.pageload();
    },
    methods: {
      pageload() {
        const url = new URLSearchParams(window.location.search);
        const id = url.get("id");
        axios.get(`/api/UICApi/CorporateClientPrint?ID=${id}`)
          .then((res) => {
            if (res.data.CorporateClientPrint) {
              this.item = {
                ...res.data.CorporateClientPrint,
                BeneficialOwners: res.data.BeneficialOwners || [],
                DirectorInfo: res.data.DirectorInfo || []
              };
            } else {
              console.error("No data received from API:", res.data.Error);
              this.item.BeneficialOwners = [];
              this.item.DirectorInfo = [];
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            this.item.BeneficialOwners = [];
            this.item.DirectorInfo = [];
          });
      },
    },
  };
</script>
<style>
  body {
    font-family: Arial, sans-serif;
    font-size: 11pt;
    line-height: 1.3;
    margin: 0;
    padding: 0;
  }

  .container {
    background: white;
    padding: 10px;
    margin: 0 auto;
    /*max-width: 800px;*/
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
  }

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

    .header img {
      width: 100px;
      margin-right: 20px;
    }

  .header-text {
    flex: 1;
    text-align: center;
  }

  .title {
    font-size: 20pt;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .subtitle {
    font-size: 14pt;
    margin-bottom: 5px;
  }

  .individual {
    font-style: italic;
    text-align: center;
    margin-bottom: 20px;
  }

  .date-line {
    text-align: right;
    margin-bottom: 20px;
  }

  .customer-info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    flex-wrap: wrap;
    gap: 20px;
  }

  .form-section {
    border: 1px solid #000;
    margin-bottom: 20px;
    padding: 20px;
    background: white;
  }

  .section-title {
    text-align: center;
    font-weight: bold;
    margin-bottom: 15px;
    text-decoration: underline;
    font-size: 13pt;
  }

  .form-row {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .form-field {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 200px;
  }

    .form-field label {
      margin-right: 10px;
    }

  .input-line {
    border-bottom: 1px solid #000;
    min-width: 150px;
    display: inline-block;
    /*height: 16px;*/
    flex: 1;
  }

  .customer-info .input-line {
    width: 400px;
  }

  .customer-info div:nth-child(2) .input-line {
    width: 50px;
  }

  .checkbox {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 1px solid #000;
    margin: 0 5px;
    vertical-align: middle;
    background: white;
  }

  .declaration {
    text-align: justify;
    margin-bottom: 10px;
    line-height: 1.4;
  }

  .signature-line {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    flex-wrap: wrap;
    gap: 20px;
  }

  .signature {
    flex: 1;
    min-width: 250px;
    text-align: center;
  }

  .signature-box {
    border-bottom: 1px solid #000;
    height: 40px;
    margin-bottom: 10px;
  }

  .documents ol {
    margin: 10px 0 10px 25px;
    padding: 0;
  }

  .documents li {
    margin-bottom: 8px;
  }

  .pep-definition ol {
    margin: 10px 0 10px 25px;
    padding: 0;
  }

  .pep-definition li {
    margin-bottom: 10px;
    text-align: justify;
  }

  .table {
    width: 100%;
    border-collapse: collapse;
    margin: 15px 0;
  }

    .table th, .table td {
      border: 1px solid #000;
      padding: 8px;
      text-align: center;
      font-size: 9pt;
      vertical-align: middle;
    }

    .table th {
      background-color: #f0f0f0;
      font-weight: bold;
    }

    .table td {
      height: 30px;
    }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f2f2f2;
  }

  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
    }
    .header {
      break-before: page; 
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/CorporateClientPrint.vue